import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import '@portalCommon/styles/variable.css';
import '@commonPackage/styles/variables.css';
import './styles/index.less';
import './styles/normalize.css';
import './styles/variable.css';
import './styles/global.css';
import 'antd/dist/reset.css';
import 'uno.css';
import zhCN from 'antd/lib/locale/zh_CN';
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import '@commonPackage/js/yidun-captcha';
import { defaultLocaleDetectOrder, i18n, i18nInit, LocaleContextProvider } from '@fuxi/eevee-hooks';
import zhJson from '@commonPackage/locales/zh.json';
import enJson from '@commonPackage/locales/en.json';

import { createPortalService } from '@portalCommon/services';
import { createService as commonCreateService } from '@commonPackage/services';

import { getTrackEnv, initSentry } from '@commonPackage/utils';
import { ConfigProvider } from 'antd';
import { ANTD_THEME, EEVEE_ICON_YAOTAI_CDN_URL, SPECIFIC_LANG } from '@commonPackage/constants';
import { EeveeIconContextProvider } from '@commonPackage/components';
import { initETracker, Platform, TrackerPidEnum } from '@yaotai/yaotai-tracker';
import { LANG_LOCAL_STORAGE_KEY, LANG_QUERY_STRING, SUPPORT_LANG_LIST, ZH } from '@yaotai/common-utils';
import { GateWayInstance, OfficialGateWayInstance, LoginGateWayInstance } from '@/services/axiosInstances';

import routerConfig from './router/config';

const langJsonList = [zhJson, enJson];
window.initNECaptchaWithFallback = initNECaptchaWithFallback;

initSentry({
  dsn: 'https://c8f48e859c074f7dadd87a7e4f8b64cb@sentry.fuxi.netease.com/18',
  env: getTrackEnv(import.meta.env.VITE_APP_MODE ?? ''),
});

initETracker({
  platform: Platform.PC,
  pid: TrackerPidEnum.YaotaiPortal,
  requiredFields: ['pid'],
  env: getTrackEnv(import.meta.env.VITE_APP_MODE ?? ''),
});

i18nInit({
  langList: SUPPORT_LANG_LIST,
  langJsonList,
  querystring: LANG_QUERY_STRING,
  localStorageKey: LANG_LOCAL_STORAGE_KEY,
  fallbackLng: ZH,
  moreInitOptions: {
    lng:
      (SUPPORT_LANG_LIST.includes(window.location.pathname.split('/')[1])
        ? window.location.pathname.split('/')[1]
        : ZH) || SPECIFIC_LANG,
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);

const detectBestMatchedLang = i18n.services.languageDetector.detect(defaultLocaleDetectOrder)[0];
commonCreateService({ GateWayInstance });
createPortalService({
  GateWayInstance,
  OfficialGateWayInstance,
  LoginGateWayInstance,
});
const router = createBrowserRouter(routerConfig);
root.render(
  <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
    <EeveeIconContextProvider cdnLink={EEVEE_ICON_YAOTAI_CDN_URL} defaultSize={16}>
      <LocaleContextProvider
        detectLang={detectBestMatchedLang}
        specifiedLang={SPECIFIC_LANG || ZH}
        langConfig={{
          zh: ['zh-CN'],
          en: ['en', 'en-US'],
        }}
        langList={SUPPORT_LANG_LIST}
        languageChangeCallback={i18n.changeLanguage.bind(i18n)}>
        <ConfigProvider theme={ANTD_THEME} locale={zhCN}>
          <RouterProvider router={router} />
        </ConfigProvider>
      </LocaleContextProvider>
    </EeveeIconContextProvider>
  </StyleProvider>,
);
